export default `
§ sidebar.switch.team: Comando
§ sidebar.switch.person: Funcionário
§ sidebar.buttons.settings: Sintonização
§ sidebar.buttons.print: Impressão
§ sidebar.buttons.share: Share
§ sidebar.buttons.logout: Logout
§ sidebar.filters.all: o tempo todo
§ sidebar.filters.year: ano
§ sidebar.filters.halfYear: meio ano
§ sidebar.filters.month: mês
§ sidebar.filters.week: semana
§ sidebar.team.total: Informação geral
§ sidebar.team.scope: módulo
§ sidebar.team.author: Funcionário
§ sidebar.team.type: Tipos de tarefas
§ sidebar.team.pr: Introdução do código
§ sidebar.team.day: Por dia
§ sidebar.team.week: Por semana
§ sidebar.team.month: Por mês
§ sidebar.team.tree: Análise de arquivos
§ sidebar.team.files: Ficheiros
§ sidebar.team.removedFiles: Arquivos excluídos
§ sidebar.team.extension: Extensions
§ sidebar.team.tasks: Lista de tarefas
§ sidebar.team.release: Releases
§ sidebar.team.hours: Horário
§ sidebar.team.commits: All commits
§ sidebar.team.changes: Todas as alterações
§ sidebar.team.words: Palavras populares
§ sidebar.team.building: Concurso
§ sidebar.team.refactor: Refactoring
§ sidebar.team.company: Companies
§ sidebar.team.country: Locations
§ sidebar.team.settings: Sintonização
§ sidebar.person.total: Informação geral
§ sidebar.person.money: Custo do trabalho
§ sidebar.person.speed: Velocidade
§ sidebar.person.day: Por dia
§ sidebar.person.week: Por semana
§ sidebar.person.month: Por mês
§ sidebar.person.tasks: Tasks
§ sidebar.person.hours: Horário
§ sidebar.person.commits: All commits
§ sidebar.person.changes: Todas as alterações
§ sidebar.person.words: Palavras populares
§ sidebar.person.settings: Sintonização
`;
